








































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { AxiosResponse, AxiosError } from 'axios';

import Product from '@/types/Product';
import User from '@/types/User';
import CollectedProduct from '@/types/CollectedProduct';

import Util from '@/util/Util';

import UserAPI from '@/services/UserAPI';

export default Vue.extend({
	name: 'CollectedProductCard',

    props: {
        collectedProduct: {
            type: Object as () => CollectedProduct
        }
	},

    data() {
		return {
			isLoading: '',
			windowWidth: window.innerHeight
		};
	},

	mounted() {
		window.onresize = () => {
			this.windowWidth = window.innerWidth;
		};
	},

	computed: {
        ...mapGetters(['getLanguage']),

		user(): User {
			return this.$store.state.user;
		},

		products(): Product[] {
			return this.$store.state.products;
		},

		isSignedIn(): boolean {
			return this.$store.getters.isSignedIn;
		},

		isMobile(): boolean {
			return this.windowWidth < 769;
		}
	},

    methods: {
		numberOfCollectedItems(collectedProduct: CollectedProduct): number {
			if (!collectedProduct || !collectedProduct.collectedItems) {
				return 0;
			} else {
				return collectedProduct.collectedItems.length;
			}
		},

		hasStickerCheck(collectedProduct: CollectedProduct) {
			return collectedProduct && collectedProduct.collectedItems && collectedProduct.collectedItems.find((collectedItem) => collectedItem.hasSticker);
		},

		list: (collectedProduct: CollectedProduct): string => {
            return Product.listProductionPeriod(collectedProduct.productionPeriods);
        },

		isCollected(productId: string): boolean {
			return this.$store.getters.isCollected(productId);
		},

		toggleProductCollected(productId: string) {
			if (!this.isSignedIn) {
				alert((this as any).$text('signInToAddToCollection'));
				return;
			}

			const handleResponse = (response: AxiosResponse) => {
				this.$store.commit('setUser', response.data.user);
			};

			const handleError = (error: AxiosError) => {
				if (error.response) {
					alert(error.response.data.message);
				}
			};

			if (this.isCollected(productId)) {
				UserAPI
					.deleteCollect(productId)
					.then(handleResponse)
					.catch(handleError);
			} else {
				UserAPI
					.postCollect(productId)
					.then(handleResponse)
					.catch(handleError);
			}

        },

		isEmpty(word: string): boolean {
			return Util.isEmpty(word);
		}
	}
});
